import DoNotDisturbOffIcon from '@mui/icons-material/DoNotDisturbOff';
import {Button, Container, Stack, Typography} from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default () => {

    const navigation = useNavigate()
    return (
        <Container sx={{minHeight: '100vh', alignItems: 'center', justifyContent: 'center'}}>
            <Stack direction="column" alignItems="center" justifyContent="center" rowGap={2}>
                <DoNotDisturbOffIcon  sx={{fontSize:60}}/>
                <Typography>Pagina nao encontrada</Typography>
                <Button onClick={e=>navigation(-1)}>Voltar</Button>
            </Stack>
        </Container>
    );
};
